module.exports = __webpack_public_path__ + "img/banner1.9c7610e4.png";